/**
 * PROTECTED FILE — DO NOT MODIFY WITHOUT PERMISSION
 *
 * Last verified working: 2026-01-03
 *
 * This file controls: provider hierarchy and app initialization
 * Changes here have historically broken core game function.
 *
 * Before modifying:
 * 1. Get explicit approval from Zach
 * 2. Create a checkpoint commit
 * 3. Test full baseline after ANY change
 */

import { useEffect } from 'react'
import './App.css'
import Pages from "@/pages/index.jsx"
import { Toaster } from "@/components/ui/toaster"
import { soundManager } from './systems/SoundManager'
import { initQAMonitor } from './systems/QAMonitor'
import { dismissAllToasts } from './components/ui/use-toast'

function App() {
  // Initialize sound system and QA monitoring on mount
  // Clear stale toasts from previous session
  useEffect(() => {
    dismissAllToasts();
    soundManager.loadPreferences();
    soundManager.init();
    initQAMonitor();
  }, []);

  return (
    <>
      <Pages />
      <Toaster />
    </>
  )
}

export default App 